// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
 
/* eslint-disable react/jsx-newline */
 
 
 
 
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useState } from 'react';
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Button,
  TableHead,
} from '@material-ui/core';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';

import { deleteOrganization, getOrganization } from 'actions';
import { CardTitle } from 'app/components/shared/card-title';
import { DeleteAlert } from 'app/components/shared/delete-alert';
import { useStyles } from 'app/components/shared/styles/view-entity';
import { LOCALES } from 'app/i18n-locale/locales-constants';
import { LanguageContext } from 'context/intl.context';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import { Organization } from 'types';
import OrgComTypTable from 'app/cards-management/merchant-pos/components/orgComTypTable';
import { fetchOrganizationExtraDetails } from 'app/configuration/organizations/organization-extra-details';
import axios from 'axios';

const ViewOrganization: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch<{ id: string }>();
  const baseURL = trimTrailingSlash(match.url);
  const intl = useIntl();

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const { locale } = useContext(LanguageContext);

  const isEnglish = locale.toLowerCase() === LOCALES.ENGLISH;

  const organizationId = match.params.id;

  const organization = useTypedSelector(
    state =>
      state.organizations.collection[organizationId] as Organization | undefined
  );

  const organizationTitle = isEnglish
    ? organization?.en_name
    : organization?.ar_name;

//auth data
let userPersonalData = '';
let userAuthData = '';
const authData = localStorage.getItem('authData');

if (authData !== null) {
  const parsedAuthData = JSON.parse(authData);
  userPersonalData = parsedAuthData.userData;
  userAuthData = parsedAuthData.userToken;
}

  /*********************  start organisation commission type states  ******************** */
  const [isMultiOrg, setIsMultiOrg] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);
  const [organisationCommissionTypes, setOrganisationCommissionTypes] = useState([]);
const [isLoading, setIsLoading] = useState(false);
/*********************  end organisation commission type states ******************** */

  /*********************  start organisation extra details (Express API)  ******************** */
  const [extraDetails, setExtraDetails] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetchOrganizationExtraDetails(organizationId)
      .then(data => {
        if (!cancelled) setExtraDetails(data);
      })
      .catch(() => {
        if (!cancelled) setExtraDetails(null);
      });

    return () => {
      cancelled = true;
    };
  }, [organizationId]);

  const dash = '—';

  const showValue = value =>
    value === null || value === undefined || value === '' ? dash : String(value);

  const showNumber = value =>
    value === null || value === undefined || value === '' ? dash : String(Number(value));

  const showBool = value =>
    value === null || value === undefined
      ? dash
      : intl.formatMessage({ id: value ? 'yes' : 'no' });

  const showKind = () => {
    if (!extraDetails) return dash;
    if (extraDetails.my_company && !extraDetails.is_pto) {
      return intl.formatMessage({ id: 'orgKindMyCompany' });
    }
    if (extraDetails.is_pto && !extraDetails.my_company) {
      return intl.formatMessage({ id: 'orgKindPto' });
    }

    return dash;
  };

  // [label i18n id, rendered value] — shown under the Ruby fields
  const extraDetailRows = [
    ['orgCode', showValue(extraDetails?.org_code)],
    ['orgKind', showKind()],
    ['orgIsSuper', showBool(extraDetails?.is_super_organisation)],
    ['orgMaxDevices', showNumber(extraDetails?.max_devices_can_added)],
    ['orgCurrentDevices', showNumber(extraDetails?.current_devices_numbers)],
    ['orgChargingBackendUrl', showValue(extraDetails?.charging_backend_baseurl)],
    ['orgThresholdValue', showNumber(extraDetails?.threshold_value)],
    ['orgServiceDayCutoff', showValue(extraDetails?.service_day_cutoff_utc)],
    ['orgCurrency', showValue(extraDetails?.currency)],
  ];
  /*********************  end organisation extra details (Express API)  ******************** */

  const hasOrganizationWriteAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'Organizations')
  );

  // eslint-disable-next-line consistent-return
  const renderCardActions = () => {
    if (hasOrganizationWriteAccess)
      return (
        <>
          <Button
            variant="outlined"
            color="primary"
            className={classes.editButton}
            component={Link}
            to={`${baseURL}/edit`}
          >
            {intl.formatMessage({ id: 'edit' })}
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            className={`${classes.editButton} ${classes.deleteButton}`}
            component={Button}
            onClick={(event: React.MouseEvent) => {
              event.stopPropagation();
              setDeleteModalOpen(true);
            }}
          >
            {intl.formatMessage({ id: 'delete' })}
          </Button>
        </>
      );
  };

  useEffect(() => {
    if (!organization) {
      dispatch(getOrganization(organizationId));
    }
  }, [dispatch, organization, organizationId]);

    /********************  start organisation commission type functions  *************************/
    useEffect(() => {
      const get_organisations_commission_types = () => {
 const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/get_organisations_commission_types?using=organisation_id`;
  
        setIsLoading(true);
  
        axios.post(url, {
          UUID_VALUE: organization?.id
        }, {
          headers: {
            'access-token': userAuthData?.access_token,
            'uid': userAuthData?.uid,
            'client': userAuthData?.client,
          }
        })
          .then((res) => {
            setOrganisationCommissionTypes(res.data.data);
            if (res.data.data.length == 0) {
  
              setIsEnabled(true);
            } else if (res.data.data.length > 0) {
  
              if (isMultiOrg) {
                setIsEnabled(true);
              } else {
                setIsEnabled(false);
              }
            }
            setIsLoading(false);
          })
          .catch((err) => {
            console.error("API ERROR", err);
            toast.error(`Sorry, ${err.message}. Please try again later.`);
            setIsLoading(false);
          });
      };
  
      organization &&  get_organisations_commission_types();
    }, [organization]);
  
/*********************  end organisation commission type functions  ******************** */
  return (
    <div className={classes.viewContainer}>
      <CardTitle title={intl.formatMessage({ id: 'oranizationInfo' })} />

      <div className={classes.infoWrapper}>
        <TableContainer className={classes.tableContainer}>
          <Table size="small" aria-label="Organization Info Table">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.row}>
                <TableCell className={classes.tableHeadCell}>
                  {organizationTitle}
                </TableCell>

                <TableCell
                  style={{ textAlign: 'end' }}
                  className={classes.tableHeadCell}
                >
                  {renderCardActions()}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow className={classes.row}>
                <TableCell>
                  {intl.formatMessage({ id: 'englishName' })}
                </TableCell>

                <TableCell align="center">{organization?.en_name}</TableCell>
              </TableRow>

              <TableRow className={classes.row}>
                <TableCell>
                  {intl.formatMessage({ id: 'arabicName' })}
                </TableCell>

                <TableCell align="center">{organization?.ar_name}</TableCell>
              </TableRow>

              {extraDetailRows.map(([labelId, value], index) => {
                const isLast = index === extraDetailRows.length - 1;

                return (
                  <TableRow className={classes.row} key={labelId}>
                    <TableCell style={isLast ? { paddingBottom: 37 } : undefined}>
                      {intl.formatMessage({ id: labelId })}
                    </TableCell>

                    <TableCell
                      align="center"
                      style={isLast ? { paddingBottom: 37 } : undefined}
                    >
                      {value}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

  {/* start organisation commission type section  */}
  <OrgComTypTable  
    //  states values
     commission_type_id={organization?.id}
     isLoading={isLoading} 
     organisationCommissionTypes={organisationCommissionTypes}
     hasCommissionsWriteAccess={undefined}
     editingRowId={undefined}
     editFormData={undefined}
     organisations={undefined}
     isAddingRow={undefined}
     com_type_is_multi={undefined}
     formData={undefined}
     com_type_en_name={undefined}
     com_type_ar_name={undefined}
     //states setters
     setIsLoading={setIsLoading}
     setOrganisationCommissionTypes={setOrganisationCommissionTypes}  
     setEditFormData={undefined}
     setFormData={undefined}
     setCom_type_is_multi={undefined}
     setCom_type_ar_name={undefined}
     setCom_type_en_name={undefined}
     //functions 
     handleEditFormChange={undefined}
     handleSaveEditRow={undefined} 
     handleCancelEditRow={undefined}
     handleEditRow={undefined} 
     handleChange={undefined}
     handleAddNewRow={undefined} 
     handleCancelAddRow={undefined}
     handleAddRow={undefined}
     remove_organisation_commission_type={undefined}
        
      />
 {/* end organisation commission type section  */}









      <Button
        variant="outlined"
        color="default"
        type="button"
        className={classes.backButton}
        onClick={() => history.replace('/configuration/organizations')}
      >
        {intl.formatMessage({ id: 'backToOrganizationList' })}
      </Button>

      <DeleteAlert
        {...{
          isOpen: isDeleteModalOpen,
          setOpen: setDeleteModalOpen,
          deleteAction: deleteOrganization,
          entityType: intl.formatMessage({ id: 'organization' }),
          entityName: organizationTitle || ' ',
          entityId: organizationId,
          onfinishNavigation: '/configuration/organizations',
        }}
      />
    </div>
  );
};

export { ViewOrganization };
